export default __webpack_public_path__ + "static/media/median-icon.efc08f2e.svg";